export const LOGO_HEIGHT = 20
export const ICON_HEIGHT = 12
